import { useEffect } from 'react';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { LoadingKey } from '../app-active-loading/LoadingKey';
import { setError } from '../store/error/action-creators';
import { useAppDispatch } from './useAppDispatch';
let timerId;
export const clearErrorTimeoutForTesting = () => {
  clearTimeout(timerId);
  timerId = undefined;
};
export const useSetErrorAfterTimeout = (loadingKey, delay = 10000, errorKey = ErrorKey.BlankScreenLoadingError) => {
  const isBlankLoadingScreen = loadingKey === LoadingKey.BlankScreenLoading;
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!isBlankLoadingScreen || timerId) return () => {};

    const setErrorKey = () => {
      dispatch(setError(errorKey));
    };

    timerId = setTimeout(setErrorKey, delay);
    return () => clearTimeout(timerId);
  });
};